<div class="tw-px-2 tw-pb-2">
    <h2>Confirm Document Update</h2>
    <mat-dialog-content>
      <h4 class="tw-pt-3">Are you sure this document is not a bank statement?</h4>
    </mat-dialog-content>
    <mat-dialog-actions class="tw-justify-end">
      <button mat-button type="button" (click)="cancel.emit()"mat-dialog-close>No</button>
      <button mat-raised-button type="button" color="primary" (click)="confirm.emit()">Yes</button>
    </mat-dialog-actions>
  </div>